<template>
	<div v-show="show">
		<div class="login">
			<div class="bg_width"></div>
			<img :src="loginImg" alt="" class="login-left" />
			<div class="login-box login-box1">
				<div class="login-box1-title">{{$t('MAIN_WEB_WELCOME_TO_LOGIN',{text:'欢迎登录'})}}！</div>
				<div class="login-box1-tip" v-if="organList && organList.length">
					{{$t('MAIN_WEB_YOUR_ACCOUNT_BELONGS_TO_MULTIPLE_ORGANIZATIONS_PLEASE',{text:'您的账号属于多个组织，请选择要登录的组织'})}}
				</div>
				<div class="login-box1-tip" v-else>{{$t('MAIN_WEB_YOU_DO_NOT_HAVE_AN_ORGANIZATION_YET',{text:'你还没有组织，请联系管理员添加权限。'})}}</div>
				<ul class="login-box1-list" v-if="organList && organList.length">
					<li v-for="(item, index) in organList" :key="index" @click="setUserOrgan(item)">
						{{ item.name }}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'organ',
	data() {
		return {
			organList: [],
            show: false,
            loginImg: '',
      		defaultImg: require('../../assets/images/pexels.png'),
		}
	},
	mounted() {
        this.loginImg = localStorage.getItem('loginImg') || this.defaultImg;
		this.getFindOrganList()
	},
	methods: {
		getFindOrganList() {
			this.$api.saas_new.getFindOrganList().then((res) => {
				if (res.data && res.data.length) {
					if (res.data.length === 1) {
						this.setUserOrgan(res.data[0])
					} else {
						this.show = true
					}
					this.organList = res.data
				}
			})
		},

		async setUserOrgan(item) {
			this.$api.account_new.switchSaas({ saasUcode: item.ucode }).then((res) => {
				if (res.success) {
					localStorage.setItem('saasName', item.name)
					localStorage.setItem('saasUcode', item.ucode)
					this.$emit('changeShowOrgan', false)
				}
			})
		},
	},
}
</script>

<style lang="stylus" scoped>
@import './css/index.styl';
</style>
